import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskStudentAgreementVm } from '../my-osk-student-agreement-vm.model';
import { IMyOskStudentAgreementIm } from '../my-osk-student-agreement-im.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentAgreementService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudentAgreement`;
  }
  get(guid: string): Observable<IMyOskStudentAgreementVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.get<IMyOskStudentAgreementVm>(this.baseUrl, { headers, params });
  }
  post(myOskStudentAgreementIm: IMyOskStudentAgreementIm): Observable<IMyOskStudentAgreementVm> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskStudentAgreementVm>(this.baseUrl, myOskStudentAgreementIm, { headers });
  }
  delete(guid: string): Observable<boolean> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (guid !== undefined && guid !== null) {
      params = params.set('guid', guid.toString());
    }
    return this.http.delete<boolean>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
